export interface BodyLockState {
    scrollPosition: number;
    cssText: string;
}

export function lockBody(): BodyLockState {
    const scrollPosition = window.pageYOffset;
    const bodyStyles = document.body.style.cssText;

    // Use position: fixed to prevent scroll jumping when overflow is hidden
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';

    // Pause navigation scroll handling while body is locked
    const mainNav = (window as any).mainNavigation;
    if (mainNav) {
        mainNav.scrollLocked = true;
    }

    return { scrollPosition, cssText: bodyStyles };
}

export function unlockBody(state: BodyLockState | string) {
    // Handle legacy string format for backwards compatibility
    if (typeof state === 'string') {
        document.body.style.cssText = state || '';
        return;
    }

    // Restore original styles
    document.body.style.cssText = state.cssText || '';

    // Update navigation state before restoring scroll position
    const mainNav = (window as any).mainNavigation;
    if (mainNav) {
        // Set lastScrollPosition to match where we're scrolling to
        mainNav.lastScrollPosition = state.scrollPosition;
        // Resume scroll handling
        mainNav.scrollLocked = false;
    }

    // Restore scroll position
    window.scrollTo(0, state.scrollPosition);
}